import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "update-notification__icon" }

import {onMounted, ref} from "vue";
import {notify} from "@kyvg/vue3-notification";
import Icon from "@/components/UI/Icon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceWorkerUpdatePopup',
  setup(__props) {

const isShowed = ref(false);
const onFoundUpdate = () => {
  isShowed.value = true;
}

const update = () => {
  localStorage.setItem('appUpdated', 'true');
  window.location.reload();
}
onMounted(() => {
  if (localStorage.getItem('appUpdated')) {
    isShowed.value = false;  // Hide notification after reload
    notify({
      type: "success",
      text: "Приложение обновлено",
    });
    localStorage.removeItem('appUpdated');
  }

  document.addEventListener('swUpdated', onFoundUpdate, {once: true});
})

return (_ctx: any,_cache: any) => {
  return (isShowed.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "update-notification animated",
        onClick: update
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(Icon, {
            name: "fire",
            size: 26,
            color: "#FFBA35"
          })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "update-notification__content" }, [
          _createElementVNode("div", { class: "update-notification__content__title" }, "Новая версия приложения"),
          _createElementVNode("div", { class: "update-notification__content_-subtitle" }, "нажмите здесь, чтобы обновить")
        ], -1))
      ]))
    : _createCommentVNode("", true)
}
}

})